import { createAsyncAction } from '../helpers';

export const faqGetFaqsAsyncAction = createAsyncAction('FAQ_GET_FAQS');
